import { lazy } from 'react';

export { Pricings } from './pricings';

export const LazyPricings = lazy(() => import('./pricings').then((mod) => ({ default: mod.Pricings })));
